import type { JSX } from 'react'
import type { IActionButtonProps } from '../ActionButton'

import {
  ButtonColors,
  ButtonCorners,
  ButtonFonts,
  ButtonIconSizes,
} from 'atoms/Button'
import { IconNames } from 'atoms/Icon'
import { COLOR, INDENTS } from 'vars/index'
import { ActionButton } from '../ActionButton'
import { ActionButtonColors, ButtonBordersWidth } from '../ActionButton.h'

export type IPrimaryBaseInlineFavoriteToggleButtonProps = IActionButtonProps

export const PrimaryBaseInlineFavoriteToggleButton = ({
  disabled,
  selected,
  icon = IconNames.favoriteToggle,
  font = ButtonFonts.Button3,
  colorDefault = ActionButtonColors.COLOR_TEXT_SECONDARY,
  colorSelectedDefault = ActionButtonColors.COLOR_TEXT_SECONDARY,
  colorHovered = ActionButtonColors.TEXT_ICON_CONSTANT_LIGHT,
  colorSelectedHovered = ActionButtonColors.TEXT_ICON_CONSTANT_LIGHT,
  colorPressed = ActionButtonColors.TEXT_ICON_CONSTANT_LIGHT,
  colorSelectedPressed = ActionButtonColors.TEXT_ICON_CONSTANT_LIGHT,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.SURFACE_OPACITY_DARK_25,
  backgroundColorDisabled = COLOR.SURFACE_DARK_3,
  borderWidth = ButtonBordersWidth.BORDER_0,
  paddings = [INDENTS.INDENT_15],
  corners = ButtonCorners.CORNERS_ROUND,
  iconSize = ButtonIconSizes.mSm,
  ...rest
}: IPrimaryBaseInlineFavoriteToggleButtonProps): JSX.Element => {
  return (
    <ActionButton
      icon={icon}
      font={font}
      selected={!!selected}
      disabled={!!disabled}
      colorDefault={colorDefault}
      colorSelectedDefault={colorSelectedDefault}
      colorHovered={colorHovered}
      colorSelectedHovered={colorSelectedHovered}
      colorPressed={colorPressed}
      colorSelectedPressed={colorSelectedPressed}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      paddings={paddings}
      corners={corners}
      iconSize={iconSize}
      {...rest}
    />
  )
}
